import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

const variants = {
  primary: 'bg-blue-400 border-blue-400 text-white hover:bg-blue-500 dark:bg-blue-300 dark:hover:bg-blue-400',
  ghost: 'bg-transparent border-transparent hover:text-blue-400 dark:text-white',
  outline:
    'bg-white text-neutral-900 border-neutral-300 hover:bg-neutral-100 hover:text-blue-400 dark:bg-neutral-900 dark:text-neutral-400 dark:border-neutral-700 dark:hover:text-white dark:hover:bg-neutral-700',
  'primary-outline':
    'bg-white text-blue-400 border-blue-400 hover:bg-neutral-100 hover:text-blue-400 dark:bg-neutral-900 dark:text-neutral-400 dark:border-neutral-700 dark:hover:text-white dark:hover:bg-neutral-700',
  success: 'text-white border-green-700 bg-green-700 hover:bg-green-800 dark:bg-green-600 dark:hover:bg-green-700',
  danger: 'bg-red-700 border-red-700 hover:bg-red-800 dark:bg-red-500 dark:hover:bg-red-700 text-white',
};

interface PillProps {
  readonly variant?: keyof typeof variants;
  readonly children?: ReactNode;
  readonly className?: string;
}

function Pill({ variant = 'primary', children, className }: PillProps) {
  return (
    <div role="contentinfo" className={twMerge('inline-block rounded-lg px-2 py-0.5 text-[10px]', variants[variant], className)}>
      {children}
    </div>
  );
}

export { Pill, variants as _variants };
